import { createSlice } from '@reduxjs/toolkit';

const NAME = 'customerRecommendation';
const INITIAL_STATE = null;

const customerRecommendationReducer = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        setRecommendation: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        clearRecommendation: () => {
            return INITIAL_STATE;
        },
    }
});

export const { setRecommendation, clearRecommendation } = customerRecommendationReducer.actions;
export const selectCustomerRecommendation = (state) => state.customerRecommendation;
export default customerRecommendationReducer.reducer;
